import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';

type Props = {
	questionSuccess: string;
	setQuestionSuccess: React.Dispatch<React.SetStateAction<string>>;
};

export default function Page2({ questionSuccess, setQuestionSuccess }: Props) {
	return (
		<>
			<h1 className="text-5xl font-medium">Nieśmiałe pytanie</h1>
			<p>
				Czy byłaby Pani tak miła i sprawiła mi tą przyjemność, aby pójść ze mną na jedzonko jutro (21.05.2025) po swojej ostatniej maturce? Jeśli
				tylko Pani pozwoli to z największym uśmiechem odbiorę Panią jutro po 12 i pojedziemy coś wszamać dobrego (w końcu po 3 latach wcale już{' '}
				<strong className="text-customBlue uppercase">niekoniecznie platonicznie</strong> {'<3'})
			</p>
			<p>Proszę o zaznaczenie swojej odpowiedzi</p>
			<RadioGroup
				value={questionSuccess}
				onChange={(e) => {
					console.log(e.target.value);
					setQuestionSuccess(e.target.value);
				}}>
				<FormControlLabel
					value="tak"
					control={
						<Radio
							sx={{
								color: '#a1ceef', // default color
								'&.Mui-checked': {
									color: '#a1ceef', // when selected
								},
							}}
						/>
					}
					label="Byłabym chętna :D"
				/>
				<FormControlLabel
					value="nie"
					control={
						<Radio
							sx={{
								color: '#a1ceef', // default color
								'&.Mui-checked': {
									color: '#a1ceef', // when selected
								},
							}}
						/>
					}
					label="Może niekoniecznie :/"
				/>
			</RadioGroup>
		</>
	);
}
